<template>
    <li class="dropdown" v-if="user">
      <a id="userSettings" aria-haspopup="true" class="user-settings" data-toggle="dropdown" href="#">
        <span class="user-name">{{user.name}}</span>
        <span class="avatar" :class="{'has-season-hat': seasonHat}">
          <!-- Natal: gorrinho no avatar, que balança de leve ao passar o mouse -->
          <svg v-if="seasonHat" class="season-avatar-hat" viewBox="0 0 40 32" aria-hidden="true">
            <defs>
              <radialGradient id="season-hat-velvet" cx="0.38" cy="0.3" r="0.9">
                <stop offset="0" stop-color="#e5484d"/>
                <stop offset="0.6" stop-color="#b3192b"/>
                <stop offset="1" stop-color="#6e0b18"/>
              </radialGradient>
              <linearGradient id="season-hat-fur" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" stop-color="#ffffff"/>
                <stop offset="1" stop-color="#e3e8ee"/>
              </linearGradient>
            </defs>
            <path d="M5 23 C7 11 15 3.5 25 4.5 C31 5 34.5 9 34 15 C31.5 11.5 28 10.5 25.5 12.5 C29 16 30 20 29.5 23 Z"
                  fill="url(#season-hat-velvet)"/>
            <rect x="3.6" y="20.4" width="28.4" height="7" rx="3.5" fill="url(#season-hat-fur)" transform="rotate(-4 18 24)"/>
            <circle cx="34" cy="15" r="3.6" fill="url(#season-hat-fur)"/>
          </svg>
          <img alt="avatar" :src="getAvatarSrc(user.avatar)" @error="setDefaultAvatar">
          <span class="status busy" />
        </span>
      </a>
      <div aria-labelledby="userSettings" class="dropdown-menu dropdown-menu-right" v-if="user">
        <div class="header-profile-actions text-center">
          <div class="header-user-profile">
            <div class="header-user">
              <img alt="Admin Template" :src="getAvatarSrc(user.avatar)" @error="setDefaultAvatar">
            </div>
            <h5>{{user.name}}</h5>
            <p class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 hide-text">{{user.email}}</p>
          </div>
          <a data-cy="profile_profile" href="#" id="profileTrigger" data-target="#modalProfile" data-toggle="modal" @click="$emit('update')">
            <i class="icon-user1" />{{t('APP.PROFILE')}}
          </a>
          <a v-if="isSecurity" data-cy="profile_change_password" href="#" data-target="#modalPassword" data-toggle="modal" @click="$emit('update')" ><i class="icon-settings1" />{{t('APP.CHANGE_PASSWORD')}}</a>
          <!-- Festas: cada pessoa escolhe se quer a neve (no Réveillon, o confete) caindo -->
          <a v-if="seasonActive" data-cy="profile_season_effects" href="#" class="season-menu-toggle" role="menuitemcheckbox"
             :aria-checked="seasonEffects ? 'true' : 'false'" @click.stop.prevent="toggleSeasonEffects">
            <i class="icon-star"/>{{ seasonNewYear ? 'Confete de Ano-Novo' : 'Neve de Natal' }}
            <span class="season-switch" :class="{'is-on': seasonEffects}" aria-hidden="true"></span>
          </a>
          <a data-cy="profile_singout" href="#" @click.stop.prevent="$emit('logout')"><i class="icon-log-out1" />{{t('APP.SINGOUT')}}</a>
        </div>
      </div>
    </li>
</template>

<script>
import {useI18n} from 'vue-i18n';
import {getAvatarSrc, setDefaultAvatar} from '@/Helpers/Avatar';
import {mapState} from 'vuex';
import {saveSeasonEffects} from '@/Helpers/global/season';

export default {
  props: ['user', 'isSecurity'],
  emits:[
    'logout',
    'update'
  ],

  setup() {
    const { t } = useI18n();
    return {t}
  },

  computed: {
    ...mapState(['seasonActive', 'seasonNewYear', 'seasonEffects']),
    seasonHat() {
      return this.seasonActive && !this.seasonNewYear;
    },
  },

  methods: {
    getAvatarSrc,
    setDefaultAvatar,
    toggleSeasonEffects() {
      const enabled = !this.seasonEffects;
      saveSeasonEffects(enabled);
      this.$store.commit('setSeasonEffects', enabled);
    },
  }
}

</script>
<style>
.hide-text {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
